var map = {
	"./1.png": 655,
	"./10.png": 500,
	"./2.png": 67,
	"./3.png": 4,
	"./4.png": 272,
	"./5.png": 265,
	"./6.png": 254,
	"./7.png": 513,
	"./8.png": 255,
	"./9.png": 827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 689;